import React, { FC } from 'react';

import { Box, Stack, Typography, useDesktop, useMediaSwitch, useMobile, useTablet } from 'Modules/ui3';
import { fileUrl } from 'Modules/ui2';
import { useAction } from 'Modules/core/redux';
import { messagingActions } from 'Modules/core/messaging';
import { useTranslation } from 'Modules/core/i18n';

import { ContentBox } from '../ContentBox';
import { TitleH1 } from '../Titles';
import { AccentButton } from '../AccentButton';
import DesktopDfa from './assets/desktopDfa.png';
import TabletDfa from './assets/tabletDfa.png';
import MobileDfa from './assets/mobileDfa.png';
import IssueIcon from './assets/issueIcon.png';
import Init from './assets/init.png';
import Individual from './assets/individual.png';
import Market from './assets/market.png';


const ABOUT = [
    {
        icon: Individual,
        text: 'individualText',
        info: 'individualInfo',
    },
    {
        icon: Init,
        text: 'initText',
        info: 'initInfo',
    },
    {
        icon: IssueIcon,
        text: 'issueText',
        info: 'issueInfo',
    },
    {
        icon: Market,
        text: 'marketText',
        info: 'marketInfo',
    },
];


export const MainInfo: FC = () => {
    const { t } = useTranslation('mainInfo');

    const isMobile = useMobile();
    const isDesktop = useDesktop();
    const isTablet = useTablet();

    const showFeedback = useAction(() => messagingActions.showModal({
        type: 'FeedbackModal',
        closeable: false,
    }));

    return (
        <>
            <ContentBox>
                <Stack direction={isMobile ? 'column' : 'row'} alignItems='stretch'>
                    <Stack
                        flex={1}
                        pl={useMediaSwitch(8, 6, 4)}
                        py={useMediaSwitch(14, 12, 6)}
                        pr={isMobile ? 4 : 0}
                        justifyContent='space-between'
                        alignItems='start'
                    >
                        <Stack spacing={isDesktop ? 6 : 3} {...isMobile && { mb: 6 }}>
                            <TitleH1>{t('title')}</TitleH1>
                            <Typography
                                component='p'
                                variant={useMediaSwitch('regularHeader2', 'regularCaption1', 'regularBody2')}
                                lineHeight={isTablet ? '20px' : 1.5}
                                color='grayscale.shade95'
                            >
                                {t('description')}
                            </Typography>
                        </Stack>
                        <AccentButton onClick={showFeedback}>
                            {t('sendRequest')}
                        </AccentButton>
                    </Stack>
                    <Stack justifyContent='center'>
                        <img src={fileUrl(useMediaSwitch(DesktopDfa, TabletDfa, MobileDfa))} width='100%' height='auto' alt='Цифровые финансовые активы' />
                    </Stack>
                </Stack>
            </ContentBox>
            <Stack spacing={2} direction={isMobile ? 'column' : 'row'} mt={2}>
                {ABOUT.map((item, idx) => (
                    <ContentBox
                        key={`item_${idx}`}
                        px={isDesktop ? 6 : 4}
                        py={isDesktop ? 8 : 4}
                        borderRadius={8}
                        flex={1}
                    >
                        <Stack
                            spacing={isDesktop ? 6 : 4}
                            {...isTablet && {
                                height: '100%',
                                justifyContent: 'space-between',
                            }}
                        >
                            <img src={fileUrl(item.icon)} width={isDesktop ? '48px' : '40px'} height='auto' alt='icon' />
                            <Box>
                                <Typography
                                    component='h4'
                                    variant={isDesktop ? 'mediumHeader2' : 'mediumBody2'}
                                    color='grayscale.shade95'
                                >
                                    {t(`about.${item.text}`)}
                                </Typography>
                                <Typography
                                    component='p'
                                    variant={isDesktop ? 'regularBody2' : 'regularCaption1'}
                                    color='grayscale.shade90'
                                    mt={isDesktop ? 3 : 2}
                                >
                                    {t(`about.${item.info}`)}
                                </Typography>
                            </Box>
                        </Stack>
                    </ContentBox>
                ))}
            </Stack>
        </>
    );
};
